module.exports = __webpack_public_path__ + "static/media/uj_dokfeltoltes1.74edfa02.jpg";